import {Tag, Tooltip, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringBrandAnalysisType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {
    ASPECT_BAR_COLOR_MAP,
    ASPECT_LANG_KEY_MAP,
    ASPECT_TAG_COLOR_MAP,
    SENTIMENT_BAR_MAX_WIDTH_PERCENT,
    SENTIMENT_MAX,
} from './tonality-aspects-const';
import {classifyAspectSentiment} from './tonality-aspects-helper';
import * as styles from './tonality-aspect-row.scss';

type PropsType = {
    aspect: AiMonitoringBrandAnalysisType['tonality']['aspects'][number];
};

// A single aspect: its name, a bar growing left/right from the centre, and a sentiment tag.
export function TonalityAspectRow(props: PropsType): JSX.Element {
    const {aspect} = props;
    const sentiment = classifyAspectSentiment(aspect.sentiment);

    // Width and side are data-driven, so they stay inline; everything static lives in the stylesheet.
    const barWidth =
        (Math.min(Math.abs(aspect.sentiment), SENTIMENT_MAX) / SENTIMENT_MAX) * SENTIMENT_BAR_MAX_WIDTH_PERCENT;
    const barSide = aspect.sentiment >= 0 ? {left: '50%'} : {right: '50%'};

    const nameNode = <Typography.Text>{aspect.name}</Typography.Text>;

    return (
        <div className={styles.tonality_aspect_row}>
            <div className={styles.tonality_aspect_row__name}>
                {aspect.evidence?.quote ? <Tooltip title={aspect.evidence.quote}>{nameNode}</Tooltip> : nameNode}
            </div>
            <div className={styles.tonality_aspect_row__track}>
                <div className={styles.tonality_aspect_row__axis} />
                <div
                    className={styles.tonality_aspect_row__bar}
                    style={{background: ASPECT_BAR_COLOR_MAP[sentiment], width: `${barWidth}%`, ...barSide}}
                />
            </div>
            <div className={styles.tonality_aspect_row__tag}>
                <Tag color={ASPECT_TAG_COLOR_MAP[sentiment]}>
                    <Locale stringKey={ASPECT_LANG_KEY_MAP[sentiment]} />
                </Tag>
            </div>
        </div>
    );
}
